
















import Vue from 'vue';
import FormField from './FormField.vue';
import customerVuex from '../../../vuex/common';
import ContainRelation from './ContainRelation.vue';
import { SubscribeFilter } from '../../../models/CustomerFilter';

interface ShortCut {
  text: string;
  value: () => Date[];
}

function getValue(timestamp: number): Date[] {
  const end = new Date();
  const start = new Date();
  start.setTime(start.getTime() - timestamp);
  return [start, end];
}

const shortcuts: ShortCut[] = [
  {
    text: '1周',
    value() {
      return getValue(3600 * 1000 * 24 * 7);
    },
  },
  {
    text: '1个月',
    value() {
      return getValue(3600 * 1000 * 24 * 30);
    },
  },
  {
    text: '3个月',
    value() {
      return getValue(3600 * 1000 * 24 * 90);
    },
  },
];

const periods: string[] | null = null;

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    FormField,
    ContainRelation,
  },
  data() {
    return {
      options: {
        shortcuts,
      },
      periods,
    };
  },
  methods: {
    updateNotIn(notIn: boolean) {
      const v = this.customerFilter.subscribe;
      v.notIn = notIn;
      this.updateSubscribeFilter(v);
    },
    updatePeriod(period: string[]) {
      const v = this.customerFilter.subscribe;
      v.periods = period;
      this.updateSubscribeFilter(v);
    },
    updateSubscribeFilter(filter: SubscribeFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'subscribe',
        value: filter,
      });
    },
  },
  mounted() {
    this.periods = this.customerFilter.subscribe.periods;
  },
  watch: {
    customerFilter(filter) {
      this.periods = JSON.parse(JSON.stringify(filter.subscribe.periods));
    },
  },
});
